import Utility from '@/common/UtilityFunctions.js';

export default class PolicyView {
  constructor(vm) {
    this.vm = vm;
  }

  get(event) {
    let trackingObject = null;

    switch (event) {
      case 'policy-view-edit-mode-activated':
        trackingObject = {
          event: 'track-event',
          eventCategory: 'Tilgå forsikring',
          eventAction: 'foretag ændringer på din forsikring - klik',
          eventLabel: Utility.getShortPolicyName(this.vm.PolicyName),
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      case 'policy-view-cancel-edit-mode':
        trackingObject = {
          event: 'track-event',
          eventCategory: 'Tilgå forsikring',
          eventAction: 'gem ændringer - annuller',
          eventLabel: Utility.getShortPolicyName(this.vm.PolicyName),
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      case 'policy-view-cover-change':
        trackingObject = {
          event: 'track-event',
          eventCategory: 'Tilgå forsikring',
          eventAction: 'dækning - ' + this.vm.cover + ' - ' + this.vm.option,
          eventLabel: Utility.getShortPolicyName(this.vm.PolicyName),
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      case 'policy-view-save-changes':
        trackingObject = {
          event: 'track-event',
          eventCategory: 'Tilgå forsikring',
          eventAction: 'gem ændringer - submit',
          eventLabel: Utility.getShortPolicyName(this.vm.PolicyName),
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      case 'policy-view-show-confirmation-modal':
        trackingObject = {
          event: 'track-event',
          eventCategory: 'Tilgå forsikring',
          eventAction: 'bekræft ændringer - vis',
          eventLabel: Utility.getShortPolicyName(this.vm.PolicyName),
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      case 'policy-view-cancel-save-proposal':
        trackingObject = {
          event: 'track-event',
          eventCategory: 'Tilgå forsikring',
          eventAction: 'bekræft ændringer - annuller',
          eventLabel: Utility.getShortPolicyName(this.vm.PolicyName),
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      case 'policy-view-save-proposal-success-error':
        trackingObject = {
          event: 'track-event',
          eventCategory: 'Tilgå forsikring',
          eventAction: 'bekræft ændringer - error',
          eventLabel: Utility.getShortPolicyName(this.vm.PolicyName),
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      case 'policy-view-save-proposal-api-error':
        trackingObject = {
          event: 'track-event',
          eventCategory: 'Tilgå forsikring',
          eventAction: 'bekræft ændringer - error',
          eventLabel: Utility.getShortPolicyName(this.vm.PolicyName),
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      case 'policy-view-save-proposal-ok':
        trackingObject = {
          event: 'track-event',
          eventCategory: 'Tilgå forsikring',
          eventAction: 'bekræft ændringer - submit',
          eventLabel: Utility.getShortPolicyName(this.vm.PolicyName),
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      case 'policy-view-show-confirmation-page':
        trackingObject = {
          event: 'track-event',
          eventCategory: 'Tilgå forsikring',
          eventAction: 'kvittering',
          eventLabel: Utility.getShortPolicyName(this.vm.PolicyName),
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
    }

    return trackingObject;
  }
}
